import React from 'react';
import { MotifButton } from '@ey-xd/motif-react';
interface CustomButtonProps {
  children: any; // Replace 'any' with the actual type of 'item'
  onClickHandler: () => void;
  disabled?: boolean;
  customSedButton?: string; // Optional prop for custom styles
}

const CustomButton: React.FC<CustomButtonProps> = ({ children, onClickHandler, disabled, customSedButton }) => (
  <MotifButton disabled={disabled} onClick={onClickHandler} className= {customSedButton}>
    {children}
  </MotifButton>
);

export default CustomButton;
